import React, { createContext, useContext, useState, useEffect } from 'react';

const SettingsContext = createContext();

const DEFAULTS = {
  theme: 'light',
  defaultView: 'board',
  defaultSort: 'lastUpdateDate',
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(() => {
    try {
      const stored = localStorage.getItem('applai_settings');
      return stored ? { ...DEFAULTS, ...JSON.parse(stored) } : DEFAULTS;
    } catch { return DEFAULTS; }
  });

  // Persist whenever settings change (theme application is handled in AppContent)
  useEffect(() => {
    localStorage.setItem('applai_settings', JSON.stringify(settings));
  }, [settings]);

  const update = (key, value) => setSettings(s => ({ ...s, [key]: value }));

  return (
    <SettingsContext.Provider value={{ settings, update }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
